<template src="./Chart.html"></template>

<script>
import topMenu from "@/components/sites/components/topMenu";
import Pagination from "@/components/components/pagination";
import Chart from '@/components/brand/dynamics/components/Chart';
import {createNamespacedHelpers} from "vuex";
import SelfDateRangePicker from "@/components/components/SelfDataRagePicker"

const {mapGetters, mapActions} = createNamespacedHelpers('sites/chartStatistic')

export default {
  name: "siteChartStatistic",
  data() {
    return {
      currentSiteId: this.$route.params.id,
      showOverlay: false,
      fromDate: null,
      toDate: null,
      chartFieldSelected: ['lead', 'totalTraffic'],
      chartShow: true,
      reRenderChart: false,
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false
      },

      fieldsList: [
        {
          key: 'lead',
          label: 'Лиды',
          color: 'ff0000'
        },
        {
          key: 'orderCount',
          label: 'Заказы',
          color: '000cff'
        },
        {
          key: 'requisition',
          label: 'КП',
          color: '04ff00'
        },
        {
          key: 'invoiced',
          label: 'Счета',
          color: 'ffff00'
        },

        {
          key: 'organicTraffic',
          label: 'Поисковый трафик',
          color: '00fff6'
        },
        {
          key: 'directTraffic',
          label: 'Прямой трафик',
          color: 'ffb600'
        },
        {
          key: 'internalTraffic',
          label: 'Внутренний трафик',
          color: 'ccff00'
        },
        {
          key: 'adTraffic',
          label: 'Рекламный трафик',
          color: '00ffc3'
        },
        {
          key: 'referralTraffic',
          label: 'Link трафик',
          color: '7b00ff'
        },
        {
          key: 'socialTraffic',
          label: 'Социальный трафик',
          color: '00b6ff'
        },
        {
          key: 'totalTraffic',
          label: 'Общий трафик',
          color: 'ff5d00'
        },
      ],
      groupOptions: [
        {
          text: 'Месяц',
          value: 'month',
        },
        {
          text: 'Неделя',
          value: 'week',
        },
        {
          text: 'День',
          value: 'day',
        },
      ],
      currentGroup: 'month',
      dateRange: {
        startDate: null,
        endDate: null
      },
      currentDateRange: {}
    }
  },
  components: {
    topMenu,
    Pagination,
    Chart,
    SelfDateRangePicker,
  },
  methods: {
    ...mapActions([
        'GET_DATA',
        'GET_EXTRIMAL_DATE',
    ]),
    changeDate: function () {
      this.getData()
    },
    getData: function () {
      if (this.isDateSelected) {
        this.$store.commit('sites/chartStatistic/CHART_DATA', [])
        this.$store.commit('sites/chartStatistic/FROM', this.fromDate)
        this.$store.commit('sites/chartStatistic/TO', this.toDate)
        this.GET_DATA({th: this})
      }
    },
    rangeUpdate: function (val) {
      this.fromDate = val.from
      this.toDate = val.to
      this.changeDate()
    }
  },
  computed: {
    ...mapGetters([
      'CHART_DATA',
      'SITE_LIST',
      'FROM',
      'TO',
      'MIN_DATE',
      'MAX_DATE',
      'CHART_DATA',
      'CURRENT_GROUP',
    ]),
    isDateSelected: function () {
      return this.fromDate != null && this.toDate != null
    },
    chartData: function () {
      // create skeleton
      let result = {
        labels: [],
        datasets: []
      }
      let datasets = result.datasets
      for (let key in this.fieldsList) {
        if (this.fieldsList[key].key == 'conversion' || this.chartFieldSelected.indexOf(this.fieldsList[key].key) === -1) {
          continue
        }
        datasets.push({
          label: this.fieldsList[key].label,
          key: this.fieldsList[key].key,
          borderColor: '#'+ this.fieldsList[key].color,
          data: [],
          fill: false,
          // backgroundColor: '#'+ this.fieldsList[key].color,
          // borderWidth: 1,
        });
      }
      // fill
      let chart = this.CHART_DATA
      for (let key in chart) {
        result.labels.push(chart[key].formatDate)
        for (let key2 in datasets) {
          let id = datasets[key2].key
          if (this.chartFieldSelected.indexOf(id) !== -1) {
            datasets[key2].data.push(chart[key][id])
          }
        }
      }

      return result
    },
    chartStyles () {
      return {
        height: '500px',
        position: 'relative'
      }
    },
    chartStylesSmall () {
      return {
        height: '320px',
        position: 'relative'
      }
    },
    conversionChartData () {
      // create skeleton
      let result = {
        labels: [],
        datasets: [
          {
            key: 'conversion',
            label: 'Конверсия',
            borderColor: '#f200ff',
            backgroundColor: 'rgba(242, 0, 255, 0.5)',
            data: [],
          }
        ]
      }

      // fill
      let chart = this.CHART_DATA
      for (let key in chart) {
        let val = chart[key]
        result.datasets[0].data.push(val.conversion)
        result.labels.push(val.formatDate)
      }

      return result
    }
  },
  watch: {
    currentSiteId(newVal) {
      this.$store.commit('sites/chartStatistic/CURRENT_SITE_ID', newVal)
      this.getData()
    },
    chartFieldSelected() {
      this.reRenderChart = !this.reRenderChart
    },
    currentGroup(newVal) {
      this.$store.commit('sites/chartStatistic/CURRENT_GROUP', newVal)
      this.getData()
    },
  },
  mounted() {
    this.fromDate = this.dateToString(this.defaultDate)
    this.toDate = this.dateToString(this.today)

    this.dateRange.startDate = this.defaultDate
    this.dateRange.endDate = this.today

    if (this.$store.getters.getAllowSection.indexOf('sites') === -1) {
      this.$router.push({name: 'permissionDenied'})
      return;
    }
    this.$store.commit('sites/chartStatistic/CURRENT_SITE_ID', this.currentSiteId)
    this.GET_EXTRIMAL_DATE({th: this})
    this.currentGroup = this.CURRENT_GROUP
  },
  created() {
    if (this.FROM != null) {
      this.fromDate = this.FROM
      this.dateRange.startDate = new Date(this.fromDate)
      console.log(this.dateRange.startDate)
    }
    if (this.TO != null) {
      this.toDate = this.TO
      this.dateRange.endDate = new Date(this.toDate)
      console.log(this.dateRange.endDate)
    }
  }
}
</script>

<style scoped>
.add-role {
  text-align: left;
}

.input-add-use {
  margin-top: 0.1em;
}

#roles i {
  display: inline-block;
  width: 100%;
  height: 38px;
  vertical-align: middle;
  line-height: 38px;
}

.hide {
  display: none;
}

.show {
  display: block;
}

#roles .t-cell {
  overflow: hidden;
}

.cell-cursor {
  cursor: cell;
}
.chart-box {
  width: 375px;
}
.chart-box {
  width: 1400px;
  display: block;
}
.chart-box-conversion {
  width: 1400px;
  display: block;
  padding-left: 12px;
}
.chart-field-selected {
  text-align: left;
}
.back-link {
  text-align: left;
  margin-bottom: 15px;
}
</style>